/**
 * Checks whether a value is a plain object, an object with a prototype of `Object`.
 *
 * @example
 * isPlainObject(new Date());
 * // => false
 *
 * isPlainObject({ foo: 1, bar: 2 });
 * // => true
 *
 * @function isPlainObject
 * @param {*} value The value to check.
 * @return {boolean} Returns `true` if `value` is a plain object, else `false`.
 */
export default function isPlainObject(value) {
	return (
		!!value &&
		typeof value === 'object' &&
		Object.prototype.toString.call(value) === '[object Object]'
	);
}
